import { CURATOR_OWNER_NONCOMMERCIAL } from 'app/shared/utils/events';

// Subset of the Event type
interface EventForCalcEventDisplayPrice {
  eventOrganizedAs: string;
  price: number;
  bookingFee: number | null;
}

interface EventForCalcEarlyBirdOriginalDisplayPrice {
  eventOrganizedAs: string;
  earlyBirdOriginalPrice?: number;
  bookingFee: number | null;
}

/** Calculates the Event price per ticket that is displayed on the Event Page */
export function calcEventDisplayPrice(
  event: EventForCalcEventDisplayPrice,
  feeIncludedInDisplayPrice: boolean
) {
  if (event.eventOrganizedAs === CURATOR_OWNER_NONCOMMERCIAL) {
    return 0;
  }

  if (feeIncludedInDisplayPrice) {
    const fee = (event.bookingFee || 0) / 100;
    return event.price + fee;
  }

  return event.price;
}

/* Calculates the Event price per ticket before early bird discount if applied to be displayed on the Event Page */
export function calcEarlyBirdOriginalDisplayPrice(
  event: EventForCalcEarlyBirdOriginalDisplayPrice,
  feeIncludedInDisplayPrice: boolean
) {
  const earlyBirdOriginalPrice = event.earlyBirdOriginalPrice || 0;
  if (event.eventOrganizedAs === CURATOR_OWNER_NONCOMMERCIAL) {
    return 0;
  }

  if (feeIncludedInDisplayPrice) {
    const fee = (event.bookingFee || 0) / 100;
    return earlyBirdOriginalPrice + fee;
  }

  return earlyBirdOriginalPrice;
}
